// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banana Pro 专业版图片生成节点样式 */

.BananaProNode-container {
  position: relative;
  background: linear-gradient(135deg, #fff9e6 0%, #fffef5 100%);
  border: 2px solid #ffb700;
  border-radius: 12px;
  padding: 16px;
  min-width: 340px;
  box-shadow: 0 4px 12px rgba(255, 183, 0, 0.25);
  transition: all 0.3s ease;
}

.BananaProNode-container:hover {
  box-shadow: 0 8px 24px rgba(255, 183, 0, 0.35);
  border-color: #ff9500;
}

.BananaProNode-title {
  font-size: 14px;
  font-weight: 700;
  color: #ff9500;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
  font-family: system-ui, -apple-system, sans-serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* 模式徽章 */
.BananaProNode-mode-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.BananaProNode-mode-t2i {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1565c0;
  border: 1px solid #64b5f6;
}

.BananaProNode-mode-i2i {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  color: #2e7d32;
  border: 1px solid #66bb6a;
}

.BananaProNode-mode-cost {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  color: #e65100;
  border: 1px solid #ffb74d;
}

.BananaProNode-version-hint {
  font-size: 11px;
  color: #666;
  font-style: italic;
  padding: 4px 0;
}

.BananaProNode-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 字段 */
.BananaProNode-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BananaProNode-label {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

/* 按钮组 */
.BananaProNode-button-group {
  display: flex;
  gap: 8px;
}

.BananaProNode-button {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.BananaProNode-button:hover:not(:disabled) {
  border-color: #ff9500;
  color: #ff9500;
  transform: translateY(-1px);
}

.BananaProNode-button-active {
  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);
  color: white;
  border-color: #ff9500;
  box-shadow: 0 2px 8px rgba(255, 149, 0, 0.3);
}

.BananaProNode-button:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

/* 分辨率提示 */
.BananaProNode-resolution-hint {
  font-size: 10px;
  color: #666;
  font-style: italic;
  padding-top: 2px;
}

/* 下拉选择 */
.BananaProNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.BananaProNode-select:focus {
  outline: none;
  border-color: #ff9500;
}

.BananaProNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 功能特性展示 */
.BananaProNode-features {
  padding: 12px;
  background: linear-gradient(135deg, #fffef5 0%, #fff9e6 100%);
  border-radius: 8px;
  border: 1px solid #ffe4b3;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BananaProNode-feature-item {
  font-size: 11px;
  color: #ff8000;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 提示信息 */
.BananaProNode-hint {
  font-size: 11px;
  color: #666;
  line-height: 1.5;
  padding: 10px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  border-left: 4px solid #ff9500;
}

.BananaProNode-hint strong {
  color: #ff8000;
}

/* 生成按钮 */
.BananaProNode-generate {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 149, 0, 0.3);
  position: relative;
  overflow: hidden;
}

.BananaProNode-generate::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.BananaProNode-generate:hover::before {
  left: 100%;
}

.BananaProNode-generate:hover:not(.BananaProNode-generate-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 149, 0, 0.4);
}

.BananaProNode-generate:active:not(.BananaProNode-generate-disabled) {
  transform: translateY(0);
}

.BananaProNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.BananaProNode-generate-disabled::before {
  display: none;
}

/* 错误提示 */
.BananaProNode-error {
  padding: 10px 12px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  color: #dc2626;
  border-left: 4px solid #dc2626;
}

/* Handle 样式 */
.BananaProNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #ff9500;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.BananaProNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

/* 不同类型的 Handle 颜色区分 */
.BananaProNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.BananaProNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.BananaProNode-handle-output {
  border-color: #ff9500;
  background: #ff9500;
}

/* Handle 标签 */
.BananaProNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(255, 149, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.BananaProNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.BananaProNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(255, 149, 0, 0.45);
  background: linear-gradient(135deg, #ffaa33 0%, #ff9500 100%);
}

/* 可点击标签的按下效果 */
.BananaProNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.BananaProNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.BananaProNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 悬停时显示标签 */
.BananaProNode-handle:hover .BananaProNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(255, 149, 0, 0.35);
}

.BananaProNode-handle:hover .BananaProNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #ff9500;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(255, 149, 0, 0.2));
}

.BananaProNode-handle-prompt .BananaProNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.BananaProNode-handle-prompt:hover .BananaProNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.BananaProNode-handle-prompt:hover .BananaProNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.BananaProNode-handle-image .BananaProNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.BananaProNode-handle-image:hover .BananaProNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.BananaProNode-handle-image:hover .BananaProNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .BananaProNode-handle .BananaProNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(255, 149, 0, 0.35);
}

.react-flow__node.selected .BananaProNode-handle-prompt .BananaProNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .BananaProNode-handle-image .BananaProNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes BananaProNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.BananaProNode-handle:hover .BananaProNode-handle-label,
.react-flow__node.selected .BananaProNode-handle .BananaProNode-handle-label {
  animation: BananaProNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 连接状态显示 */
.BananaProNode-status {
  padding: 12px;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.BananaProNode-status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.BananaProNode-status-item:not(:last-child) {
  border-bottom: 1px dashed #e5e7eb;
  margin-bottom: 6px;
  padding-bottom: 8px;
}

.BananaProNode-status-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.BananaProNode-status-value {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.BananaProNode-status-connected {
  color: #10b981;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 1px solid #10b981;
}

.BananaProNode-status-disconnected {
  color: #ef4444;
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 1px solid #ef4444;
}

/* 复制按钮 */
.BananaProNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ffb700;
  border-radius: 6px;
  background: white;
  color: #ff9500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(255, 149, 0, 0.2);
}

.BananaProNode-container:hover .BananaProNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.BananaProNode-duplicate-button:hover {
  background: linear-gradient(135deg, #fffef5 0%, #fff9e6 100%);
  border-color: #ff9500;
  color: #ff8000;
  transform: scale(1.1);
}

.BananaProNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .BananaProNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .BananaProNode-container {
    min-width: 280px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/BananaProNode.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,8CAA8C;EAC9C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,sEAAsE;AACxE;;AAEA,WAAW;AACX;EACE,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Banana Pro 专业版图片生成节点样式 */\n\n.BananaProNode-container {\n  position: relative;\n  background: linear-gradient(135deg, #fff9e6 0%, #fffef5 100%);\n  border: 2px solid #ffb700;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 340px;\n  box-shadow: 0 4px 12px rgba(255, 183, 0, 0.25);\n  transition: all 0.3s ease;\n}\n\n.BananaProNode-container:hover {\n  box-shadow: 0 8px 24px rgba(255, 183, 0, 0.35);\n  border-color: #ff9500;\n}\n\n.BananaProNode-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #ff9500;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n  font-family: system-ui, -apple-system, sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/* 模式徽章 */\n.BananaProNode-mode-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.BananaProNode-mode-t2i {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  color: #1565c0;\n  border: 1px solid #64b5f6;\n}\n\n.BananaProNode-mode-i2i {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  color: #2e7d32;\n  border: 1px solid #66bb6a;\n}\n\n.BananaProNode-mode-cost {\n  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n  color: #e65100;\n  border: 1px solid #ffb74d;\n}\n\n.BananaProNode-version-hint {\n  font-size: 11px;\n  color: #666;\n  font-style: italic;\n  padding: 4px 0;\n}\n\n.BananaProNode-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 字段 */\n.BananaProNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.BananaProNode-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* 按钮组 */\n.BananaProNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.BananaProNode-button {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.BananaProNode-button:hover:not(:disabled) {\n  border-color: #ff9500;\n  color: #ff9500;\n  transform: translateY(-1px);\n}\n\n.BananaProNode-button-active {\n  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);\n  color: white;\n  border-color: #ff9500;\n  box-shadow: 0 2px 8px rgba(255, 149, 0, 0.3);\n}\n\n.BananaProNode-button:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n}\n\n/* 分辨率提示 */\n.BananaProNode-resolution-hint {\n  font-size: 10px;\n  color: #666;\n  font-style: italic;\n  padding-top: 2px;\n}\n\n/* 下拉选择 */\n.BananaProNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.BananaProNode-select:focus {\n  outline: none;\n  border-color: #ff9500;\n}\n\n.BananaProNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 功能特性展示 */\n.BananaProNode-features {\n  padding: 12px;\n  background: linear-gradient(135deg, #fffef5 0%, #fff9e6 100%);\n  border-radius: 8px;\n  border: 1px solid #ffe4b3;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.BananaProNode-feature-item {\n  font-size: 11px;\n  color: #ff8000;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* 提示信息 */\n.BananaProNode-hint {\n  font-size: 11px;\n  color: #666;\n  line-height: 1.5;\n  padding: 10px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-radius: 8px;\n  border-left: 4px solid #ff9500;\n}\n\n.BananaProNode-hint strong {\n  color: #ff8000;\n}\n\n/* 生成按钮 */\n.BananaProNode-generate {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(255, 149, 0, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.BananaProNode-generate::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.5s;\n}\n\n.BananaProNode-generate:hover::before {\n  left: 100%;\n}\n\n.BananaProNode-generate:hover:not(.BananaProNode-generate-disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 149, 0, 0.4);\n}\n\n.BananaProNode-generate:active:not(.BananaProNode-generate-disabled) {\n  transform: translateY(0);\n}\n\n.BananaProNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.BananaProNode-generate-disabled::before {\n  display: none;\n}\n\n/* 错误提示 */\n.BananaProNode-error {\n  padding: 10px 12px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #dc2626;\n  border-left: 4px solid #dc2626;\n}\n\n/* Handle 样式 */\n.BananaProNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #ff9500;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.BananaProNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n/* 不同类型的 Handle 颜色区分 */\n.BananaProNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.BananaProNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.BananaProNode-handle-output {\n  border-color: #ff9500;\n  background: #ff9500;\n}\n\n/* Handle 标签 */\n.BananaProNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #ff9500 0%, #ff8000 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(255, 149, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.BananaProNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.BananaProNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(255, 149, 0, 0.45);\n  background: linear-gradient(135deg, #ffaa33 0%, #ff9500 100%);\n}\n\n/* 可点击标签的按下效果 */\n.BananaProNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.BananaProNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.BananaProNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 悬停时显示标签 */\n.BananaProNode-handle:hover .BananaProNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(255, 149, 0, 0.35);\n}\n\n.BananaProNode-handle:hover .BananaProNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #ff9500;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(255, 149, 0, 0.2));\n}\n\n.BananaProNode-handle-prompt .BananaProNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.BananaProNode-handle-prompt:hover .BananaProNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.BananaProNode-handle-prompt:hover .BananaProNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.BananaProNode-handle-image .BananaProNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.BananaProNode-handle-image:hover .BananaProNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.BananaProNode-handle-image:hover .BananaProNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .BananaProNode-handle .BananaProNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(255, 149, 0, 0.35);\n}\n\n.react-flow__node.selected .BananaProNode-handle-prompt .BananaProNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .BananaProNode-handle-image .BananaProNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes BananaProNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.BananaProNode-handle:hover .BananaProNode-handle-label,\n.react-flow__node.selected .BananaProNode-handle .BananaProNode-handle-label {\n  animation: BananaProNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 连接状态显示 */\n.BananaProNode-status {\n  padding: 12px;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.BananaProNode-status-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.BananaProNode-status-item:not(:last-child) {\n  border-bottom: 1px dashed #e5e7eb;\n  margin-bottom: 6px;\n  padding-bottom: 8px;\n}\n\n.BananaProNode-status-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.BananaProNode-status-value {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 12px;\n  transition: all 0.2s ease;\n}\n\n.BananaProNode-status-connected {\n  color: #10b981;\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  border: 1px solid #10b981;\n}\n\n.BananaProNode-status-disconnected {\n  color: #ef4444;\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border: 1px solid #ef4444;\n}\n\n/* 复制按钮 */\n.BananaProNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ffb700;\n  border-radius: 6px;\n  background: white;\n  color: #ff9500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(255, 149, 0, 0.2);\n}\n\n.BananaProNode-container:hover .BananaProNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.BananaProNode-duplicate-button:hover {\n  background: linear-gradient(135deg, #fffef5 0%, #fff9e6 100%);\n  border-color: #ff9500;\n  color: #ff8000;\n  transform: scale(1.1);\n}\n\n.BananaProNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .BananaProNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* 响应式设计 */\n@media (max-width: 480px) {\n  .BananaProNode-container {\n    min-width: 280px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
